export const radarOriginalSize = 560;
export const radarBoundariesRatio = (225 * 2) / radarOriginalSize;
export const radarHighToAverageBoundariesRatio =
	(100 * 2) / radarOriginalSize / radarBoundariesRatio;
export const radarAverageToLowBoundariesRatio =
	(165 * 2) / radarOriginalSize / radarBoundariesRatio;
export const radarLikelyToUndefinedBoundariesRatio =
	(275 * 2) / radarOriginalSize / radarBoundariesRatio;
